import React, { useEffect } from 'react';
import { X, MapPin, CalendarDays, Ruler } from 'lucide-react';

/*
 * Infrastructure project detail — a premium split "blueprint dossier" popup.
 * Left: the project image under a blueprint overlay + a floating date plate.
 * Right: an engineering eyebrow, title, full body, a spec strip, and a CTA.
 * Slides up; Esc / backdrop / ✕ close it.
 */
export default function InfraProjectModal({ project, onClose }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  if (!project) return null;
  const specs = [
    { icon: CalendarDays, label: 'Delivered', value: project.date },
    { icon: Ruler, label: 'Discipline', value: 'Infrastructure' },
    { icon: MapPin, label: 'Region', value: 'Israel' },
  ];

  return (
    <div className="pmodal" onClick={onClose} role="dialog" aria-modal="true" aria-label={project.title}>
      <div className="pmodal__card pmodal__card--infra" onClick={(e) => e.stopPropagation()}>
        <button className="pmodal__close" onClick={onClose} aria-label="Close">
          <X size={22} />
        </button>

        <div className="imodal__media">
          <img src={project.image} alt={project.title} />
          <div className="imodal__grid" aria-hidden="true" />
          <span className="imodal__corner imodal__corner--tl" aria-hidden="true" />
          <span className="imodal__corner imodal__corner--br" aria-hidden="true" />
          <span className="imodal__date">
            <CalendarDays size={14} /> {project.date}
          </span>
        </div>

        <div className="imodal__body">
          <span className="imodal__eyebrow">
            <Ruler size={15} /> Infrastructure Project
          </span>
          <h2 className="imodal__title">{project.title}</h2>
          <p className="imodal__text">{project.body}</p>

          <ul className="imodal__specs">
            {specs.map(({ icon: Icon, label, value }) => (
              <li key={label}>
                <Icon size={16} />
                <span className="imodal__spec-label">{label}</span>
                <span className="imodal__spec-value">{value}</span>
              </li>
            ))}
          </ul>

          <a className="btn btn--accent imodal__cta" href="/#contact" onClick={onClose}>
            Discuss a project like this
          </a>
        </div>
      </div>
    </div>
  );
}
